import { Directive, HostListener, ElementRef, OnInit, Input } from '@angular/core';

const HEADSPACE = 55;
const FLOORSPACE = 2;
const DEFAULT_SUB_MENU_SELECTOR = '.nav-sub-menu';

/**
* Ensures a menu item does not extend beyond the viewport
* and allows scrolling if all items cannot fit.
*/
@Directive({
  selector: '[hbMenuViewportRestrict]',
})
export class MenuViewportRestrictDirective implements OnInit {

  private originalStyleProps: any;

  @Input('hbMenuViewportRestrict') subMenuSelector: string;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    // store the initial properties in case they are already set inline, probably null though
    this.originalStyleProps = {
      top: this.el.nativeElement.style.top,
      marginTop: this.el.nativeElement.style.marginTop,
      overflowY: this.el.nativeElement.style.overflowY,
      maxHeight: this.el.nativeElement.style.maxHeight,
    };
  }

  private hasClass(target: any, elementClassName: string) {
    return new RegExp('(\\s|^)' + elementClassName + '(\\s|$)').test(target.className);
  }

  @HostListener('mouseover', [])
  ensureCorrectSizeAndPosition() {
    const subMenuSelector = this.subMenuSelector || DEFAULT_SUB_MENU_SELECTOR;
    const subMenu = this.el.nativeElement.querySelector(subMenuSelector) as HTMLElement;
    const body = document.querySelector('body');
    if (!subMenu) {
      return;
    }
    /* set style props to original position so not inheriting previous resize state */
    this.resetElementState();

    if (!this.hasClass(body, 'sidebar-minimized') || this.hasClass(body, 'sidebar-mobile-show')) {
      return;
    }

    if (this.isBeyondViewportBottom(subMenu)) {
      subMenu.style.marginTop = '0px';
      let menuRect = subMenu.getBoundingClientRect();
      const viewPortHeight = (window.innerHeight || document.documentElement.clientHeight);
      const offset = menuRect.bottom - viewPortHeight;
      subMenu.style.marginTop = `${-1-offset}px`;

      if(this.isAboveViewportTop(subMenu)) { // In case menu has been pushed up over the top
        subMenu.style.overflowY = 'scroll';
        subMenu.style.maxHeight = `${window.innerHeight - HEADSPACE}px`;
        menuRect = subMenu.getBoundingClientRect();
        const currTopValue = this.pxToInt(subMenu.style.marginTop);
        subMenu.style.marginTop = `${currTopValue - (menuRect.top - HEADSPACE)}px`;
      }

    } else { // Menu fits in viewport so ensure style properties are erased / returned to original state
      this.resetElementState();
    }
  }

  @HostListener('mouseleave', [])
  resetElementState(){
    const subMenuSelector = this.subMenuSelector || DEFAULT_SUB_MENU_SELECTOR;
    const subMenu = this.el.nativeElement.querySelector(subMenuSelector) as HTMLElement;
    if (!subMenu) {
      return;
    }
    Object.keys(this.originalStyleProps).forEach(key => {
      subMenu.style[key] = this.originalStyleProps[key];
    });
  }

  private pxToInt(val: string): number {
    return val ? parseInt(val.replace('px', ''), 10) : null;
  }

  private isBeyondViewportBottom(subMenu: HTMLElement): boolean {
    const menuRect = subMenu.getBoundingClientRect();
    const viewPortHeight = (window.innerHeight || document.documentElement.clientHeight);
    return menuRect.bottom + FLOORSPACE > viewPortHeight;
  }

  private isAboveViewportTop(subMenu: HTMLElement): boolean {
    const menuRect = subMenu.getBoundingClientRect();
    return menuRect.top < HEADSPACE;
  }
}

export const MENU_DIRECTIVES = [MenuViewportRestrictDirective];
